<template>

	<!-- Main Sidebar -->
	<a-layout-sider
		collapsible
		class="sider-primary"
		breakpoint="lg"
		collapsed-width="0"
		width="250px"
		:collapsed="sidebarCollapsed"
		@collapse="$emit('toggleSidebar', ! sidebarCollapsed)"
		:trigger="null"
		:class="['ant-layout-sider-' + sidebarColor, 'ant-layout-sider-' + sidebarTheme]"
		theme="light"
		:style="{ backgroundColor: 'transparent',}">
			<div class="brand"><img src="images/zerocents-logo-small.jpeg" alt=""></div>
			<hr>

			<!-- Sidebar Navigation Menu -->
			<a-menu theme="light" mode="inline">
				<!-- First Group: Main Navigation (only shown if user has an active organization selected) -->
				<template v-if="hasActiveOrganization">
					<a-menu-item>
						<router-link to="/dashboard" @click.native="handleLinkClick">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
									<path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
									<path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">Dashboard</span>
						</router-link>
					</a-menu-item>
					<a-menu-item>
						<router-link to="/transactions" @click.native="handleLinkClick">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z" fill="#111827"/>
									<path fill-rule="evenodd" clip-rule="evenodd" d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">Transactions</span>
						</router-link>
					</a-menu-item>
					<a-menu-item>
						<router-link to="/reports" @click.native="handleLinkClick">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
									<path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
									<path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">Reports</span>
						</router-link>
					</a-menu-item>
					<a-menu-item>
						<router-link to="/categories" @click.native="handleLinkClick">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z" fill="#111827"/>
									<path d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z" fill="#111827"/>
									<path d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">Categories</span>
						</router-link>
					</a-menu-item>
					<a-menu-item>
						<router-link to="/users" @click.native="handleLinkClick">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3C7.65685 3 9 4.34315 9 6Z" fill="#111827"/>
									<path d="M17 6C17 7.65685 15.6569 9 14 9C12.3431 9 11 7.65685 11 6C11 4.34315 12.3431 3 14 3C15.6569 3 17 4.34315 17 6Z" fill="#111827"/>
									<path d="M12.9291 17C12.9758 16.6734 13 16.3395 13 16C13 14.3648 12.4393 12.8606 11.4998 11.6691C12.2352 11.2435 13.0892 11 14 11C16.7614 11 19 13.2386 19 16V17H12.9291Z" fill="#111827"/>
									<path d="M6 11C8.76142 11 11 13.2386 11 16V17H1V16C1 13.2386 3.23858 11 6 11Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">Users</span>
						</router-link>
					</a-menu-item>
				</template>

				<!-- Second Group: Organizations -->
				<a-menu-item class="menu-item-header">
					Organizations
				</a-menu-item>
				<a-menu-item>
					<router-link to="/create-organization" @click.native="handleLinkClick">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M10 5C10 4.44772 10.4477 4 11 4C11.5523 4 12 4.44772 12 5V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H12V15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15V11H6C5.44772 11 5 10.5523 5 10C5 9.44772 5.44772 9 6 9H10V5Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Create Organization</span>
					</router-link>
				</a-menu-item>
				<!-- Organization switching links (only shown if user has multiple active organizations) -->
				<template v-if="hasActiveOrganization && organizations.length > 1">
					<a-menu-item
						v-for="org in organizations"
						:key="org.id"
						:class="{ 'ant-menu-item-selected': org.id === selectedOrgId }"
					>
						<a @click="handleOrganizationSwitch(org.id)">
							<span class="icon">
								<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M3 4C3 3.44772 3.44772 3 4 3H9C9.55228 3 10 3.44772 10 4V9C10 9.55228 9.55228 10 9 10H4C3.44772 10 3 9.55228 3 9V4Z" fill="#111827"/>
									<path d="M3 13C3 12.4477 3.44772 12 4 12H9C9.55228 12 10 12.4477 10 13V16C10 16.5523 9.55228 17 9 17H4C3.44772 17 3 16.5523 3 16V13Z" fill="#111827"/>
									<path d="M13 3C12.4477 3 12 3.44772 12 4V9C12 9.55228 12.4477 10 13 10H16C16.5523 10 17 9.55228 17 9V4C17 3.44772 16.5523 3 16 3H13Z" fill="#111827"/>
									<path d="M12 13C12 12.4477 12.4477 12 13 12H16C16.5523 12 17 12.4477 17 13V16C17 16.5523 16.5523 17 16 17H13C12.4477 17 12 16.5523 12 16V13Z" fill="#111827"/>
								</svg>
							</span>
							<span class="label">{{ org.name }}</span>
						</a>
					</a-menu-item>
				</template>

				<!-- Third Group: Account Pages -->
				<a-menu-item class="menu-item-header">
					Account Pages
				</a-menu-item>
				<a-menu-item>
					<router-link to="/profile" @click.native="handleLinkClick">
						<span class="icon">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z" fill="#111827"/>
							</svg>
						</span>
						<span class="label">Profile</span>
					</router-link>
				</a-menu-item>
				<a-menu-item>
					<a @click="handleLogout">
						<span class="icon">
							<svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
								<title>logout</title>
								<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
									<g id="Tables" transform="translate(-58.000000, -507.000000)" fill="#BFBFBF" fill-rule="nonzero">
										<g id="sidebar" transform="translate(33.000000, 43.000000)">
											<g id="sign-up" transform="translate(16.000000, 455.000000)">
												<g id="duplicate" transform="translate(9.000000, 9.000000)">
													<path d="M4,6 C4,4.89543 4.89543,4 6,4 L12,4 C13.1046,4 14,4.89543 14,6 L14,12 C14,13.1046 13.1046,14 12,14 L6,14 C4.89543,14 4,13.1046 4,12 L4,6 Z" id="Path"></path>
													<path d="M2,0 C0.89543,0 0,0.89543 0,2 L0,8 C0,9.1046 0.89543,10 2,10 L2,4 C2,2.8954305 2.8954305,2 4,2 L10,2 L10,2 C10,0.89543 9.1046,0 8,0 L2,0 Z" id="Path"></path>
												</g>
											</g>
										</g>
									</g>
								</g>
							</svg>
						</span>
						<span class="label">Logout</span>
					</a>
				</a-menu-item>
			</a-menu>
			<!-- / Sidebar Navigation Menu -->

	</a-layout-sider>
	<!-- / Main Sidebar -->

</template>

<script>
	import { OrganizationManager } from '../../auth.js';

	export default ({
		props: {
			// Sidebar collapsed status.
			sidebarCollapsed: {
				type: Boolean,
				default: false,
			},

			// Main sidebar color.
			sidebarColor: {
				type: String,
				default: "primary",
			},

			// Main sidebar theme : light, white, dark.
			sidebarTheme: {
				type: String,
				default: "light",
			},
		},
		data() {
			return {
				organizations: [],
				selectedOrgId: null,
			}
		},
		async mounted() {
			// Load organizations
			await this.loadOrganizations();
		},
		computed: {
			hasActiveOrganization() {
				// User has an active organization if they have organizations AND one is selected
				return this.organizations.length > 0 && this.selectedOrgId !== null;
			}
		},
		watch: {
			// Reload organizations when route changes (e.g., after creating a new organization)
			'$route'() {
				this.loadOrganizations();
			}
		},
		methods: {
			async loadOrganizations() {
				try {
					// Try to get organizations from localStorage first
					let orgs = OrganizationManager.getUserOrganizations();

					// If not in localStorage, fetch from API
					if (!orgs || orgs.length === 0) {
						orgs = await OrganizationManager.fetchUserOrganizations();
					}

					// Filter to only enabled organizations
					const enabledOrgs = orgs.filter(org => org.enabled !== false);
					this.organizations = enabledOrgs;

					// Set selected organization ID from localStorage
					const selectedId = OrganizationManager.getSelectedOrganizationId();
					if (selectedId) {
						const parsedId = parseInt(selectedId);
						// Verify the selected org is in the enabled list
						const orgExists = enabledOrgs.some(org => org.id === parsedId);
						if (orgExists) {
							this.selectedOrgId = parsedId;
						} else {
							// Selected org not accessible - clear it
							localStorage.removeItem('selectedOrganizationId');
							this.selectedOrgId = null;
						}
					}

					// If no selected org and user has enabled organizations, try to select one
					if (this.selectedOrgId === null && enabledOrgs.length > 0) {
						for (const org of enabledOrgs) {
							try {
								await OrganizationManager.selectOrganization(org.id);
								this.selectedOrgId = org.id;
								break;
							} catch (orgError) {
								console.log(`Could not select organization ${org.id}:`, orgError.message);
								// Continue to try next organization
							}
						}
						// If no organization could be selected, selectedOrgId remains null
					}
				} catch (error) {
					console.error('Error loading organizations:', error);
				}
			},

			async handleOrganizationSwitch(orgId) {
				try {
					// Call the backend to get new JWT token with organization context
					await OrganizationManager.selectOrganization(orgId);

					// If already on dashboard, reload to refresh data
					// Otherwise navigate to dashboard
					if (this.$route.path === '/dashboard') {
						this.$router.go(0);
					} else {
						this.$router.push('/dashboard');
					}
				} catch (error) {
					console.error('Error changing organization:', error);
					this.$message.error('Failed to switch organization');
				}
			},

			handleLinkClick() {
				// Close the sidebar when a link is clicked, but only on mobile view (lg breakpoint and below)
				if (!this.sidebarCollapsed && window.innerWidth <= 992) {
					this.$emit('toggleSidebar', true);
				}
			},

			handleLogout() {
				// Clear all authentication data
				localStorage.removeItem('token');
				localStorage.removeItem('user');
				localStorage.removeItem('selectedOrganizationId');
				localStorage.removeItem('userOrganizations');
				sessionStorage.removeItem('token');
				sessionStorage.removeItem('user');

				// Redirect to sign-in page
				this.$router.push('/sign-in');
			}
		},
	})

</script>
